import React from 'react'
import './container.css'
const Container = () => {
  return (
    <div className="container1" >
      <div className="left1">
        <p>The Quran Tafseer Course is a valuable resource for anyone seeking to deepen their understanding of the Quran. It offers a comprehensive and insightful exploration of the text, guided by expert instructors in a supportive learning environment. Whether you are new to Tafseer or looking to expand your existing knowledge, this course provides the tools and resources needed to enrich your spiritual journey and connection with the Quran.</p>
      </div>
      <div className="right2">
        <img src="./images/Al-Quran-min.png" alt="Description" style={{height:'400px'}} />
      </div>
    </div>
  )
}

export default Container
